"use client"

import SelectPlacement from "../components/SelectPlacement"
import FightDownIcon from "@/components/icons/FightDownIcon"
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks'
import { flightActions } from '@/lib/redux/features/flight/reduce'
import { FC } from "react"
import { InputSearchRef } from "../components/SelectPlacement/InputSearch"
import { useTranslation } from "react-i18next"
import { getRefSelectDateFromTo } from "./SelectDateFromTo.wrapper"

type SelectAirportToProps = {
  size?: 'small' | 'default',
  layout?: 'default' | 'hero',
  indexInputFlight: number,
  onlyContent?: boolean
}

export const refToAirport: { current: InputSearchRef | null } = { current: null }

const SelectAirportTo: FC<SelectAirportToProps> = ({ size = 'default', layout = 'default', onlyContent, indexInputFlight }) => {
  const toAirport = useAppSelector(state => state.flight.inputFlights[indexInputFlight]?.toAirport)
  const { t } = useTranslation()
  const searchingTo = useAppSelector(state => state.flight.searchingTo)
  const checkedItinerary = useAppSelector(state => state.flight.checkedItinerary)

  const dispatch = useAppDispatch()

  return (
    <SelectPlacement
      popoverPlacement="bottomRight"
      onlyContent={onlyContent}
      layout={layout}
      size={size}
      getRefInput={(curr) => { refToAirport.current = curr; }}
      value={toAirport}
      label={t("flight.to")}
      icon={<FightDownIcon />}
      placeholder={t("flight.to_placeholder")}
      searching={searchingTo}
      onChange={(airport) => {
        dispatch(flightActions.selectToAirport({ indexInputFlight, toAirport: airport }))
        if (!airport) return
        if (checkedItinerary) {
          dispatch(flightActions.selectFromAirport({ indexInputFlight: 1, fromAirport: airport }))
        }
        getRefSelectDateFromTo(indexInputFlight)?.focuse('from')
      }}
      chooseCurrentLy={(from, to) => {
        dispatch(flightActions.selectToAirport({ indexInputFlight, toAirport: to }))
        dispatch(flightActions.selectFromAirport({ indexInputFlight, fromAirport: from }))
      }}
      onSearch={(val) => {
        if (val) {
          if (!searchingTo) {
            dispatch(flightActions.updateSearchingTo(true))
          }
        } else {
          if (searchingTo) {
            dispatch(flightActions.updateSearchingTo(false))
          }
        }
      }}
    />
  )
}

SelectAirportTo.displayName = 'SelectAirportTo'

export default SelectAirportTo